import axiosInstance from './axiosConfig';

export interface CredentialStatus {
    connected: boolean;
    login: string;
    lastAuthFailureAt: string | null;
}

export interface SessionLinkStatus {
    linked: boolean;
    repoUrl: string;
    branch: string;
    lastPushedAt: string | null;
    lastPushedSha: string | null;
    lastPushStatus: string | null;
}

export interface PushResult {
    headSha: string;
    branch: string;
    repoUrl: string;
    pushedAt: string;
}

export type GithubErrorCode =
    | 'PAT_INVALID'
    | 'REPO_NOT_FOUND'
    | 'AUTH_FAILED'
    | 'LEASE_FAILED'
    | 'NOT_LINKED'
    | 'NOT_CONNECTED'
    | 'INTERNAL_ERROR';

export async function connectGithubPat(pat: string) {
    try {
        const response = await axiosInstance.post('/github/credential/connect', { pat });
        return response.data;
    } catch (error) {
        console.error('Error connecting GitHub PAT', error);
        throw error;
    }
}

export async function replaceGithubPat(pat: string) {
    try {
        const response = await axiosInstance.post('/github/credential/replace', { pat });
        return response.data;
    } catch (error) {
        console.error('Error replacing GitHub PAT', error);
        throw error;
    }
}

export async function getGithubCredentialStatus() {
    try {
        const response = await axiosInstance.get('/github/credential/status');
        return response.data;
    } catch (error) {
        console.error('Error fetching GitHub credential status', error);
        throw error;
    }
}

export async function disconnectGithub() {
    try {
        const response = await axiosInstance.delete('/github/credential/disconnect');
        return response.data;
    } catch (error) {
        console.error('Error disconnecting GitHub', error);
        throw error;
    }
}

export async function linkGithubRepo(sessionId: string, repoUrl: string, branch?: string) {
    try {
        const response = await axiosInstance.post(`/github/session/${sessionId}/link`, { repoUrl, branch });
        return response.data;
    } catch (error) {
        console.error('Error linking GitHub repo', error);
        throw error;
    }
}

export async function getGithubSessionStatus(sessionId: string) {
    try {
        const response = await axiosInstance.get(`/github/session/${sessionId}/status`);
        return response.data;
    } catch (error) {
        console.error('Error fetching GitHub session status', error);
        throw error;
    }
}

export async function unlinkGithubRepo(sessionId: string) {
    try {
        const response = await axiosInstance.delete(`/github/session/${sessionId}/link`);
        return response.data;
    } catch (error) {
        console.error('Error unlinking GitHub repo', error);
        throw error;
    }
}

export async function pushToGithub(sessionId: string, force?: boolean) {
    try {
        const response = await axiosInstance.post(`/github/push/${sessionId}`, { force });
        return response.data;
    } catch (error) {
        console.error('Error pushing to GitHub', error);
        throw error;
    }
}
